module.exports = __webpack_public_path__ + "static/media/ad2.014d0af6.png";